import React from "react";
import ReactEcharts from "echarts-for-react";

const GAUGE_CENTER = ["50%", "45%"];

const makeGaugeOption = (title, value) => ({
  series: [
    {
      // Background dial face
      type: "gauge",
      center: GAUGE_CENTER,
      radius: "80%",
      startAngle: 0,
      endAngle: 360,
      min: 0,
      max: 1,
      silent: true,
      pointer: { show: false },
      axisLine: {
        lineStyle: {
          width: 72,
          color: [[1, "#2a2e36"]],
        },
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { show: false },
    },
    {
      // Outer bezel surface
      type: "gauge",
      center: GAUGE_CENTER,
      radius: "88%",
      startAngle: 0,
      endAngle: 360,
      min: 0,
      max: 1,
      silent: true,
      pointer: { show: false },
      axisLine: {
        lineStyle: {
          width: 10,
          color: [[1, "#3e434d"]],
        },
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { show: false },
    },
    {
      // Bezel highlight edge
      type: "gauge",
      center: GAUGE_CENTER,
      radius: "88%",
      startAngle: 0,
      endAngle: 360,
      min: 0,
      max: 1,
      silent: true,
      pointer: { show: false },
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#666"]],
        },
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { show: false },
    },
    {
      // Main gauge
      type: "gauge",
      center: GAUGE_CENTER,
      radius: "70%",
      startAngle: 210,
      endAngle: -30,
      min: 0,
      max: 2.0,
      splitNumber: 4,
      pointer: {
        length: "70%",
        width: 4,
        itemStyle: { color: "#ddd" },
      },
      anchor: {
        show: true,
        size: 8,
        itemStyle: { color: "#888", borderColor: "#aaa", borderWidth: 1 },
      },
      axisLine: {
        lineStyle: {
          width: 12,
          color: [
            [0.5, "#ff4444"],
            [0.7, "#ffaa00"],
            [1, "#44ff44"],
          ],
        },
      },
      axisTick: { show: false },
      splitLine: {
        length: 8,
        lineStyle: { color: "#ccc", width: 1 },
      },
      axisLabel: {
        distance: 16,
        color: "#ccc",
        fontSize: 10,
      },
      title: {
        show: true,
        offsetCenter: [0, "70%"],
        fontSize: 12,
        color: "#ccc",
      },
      detail: {
        valueAnimation: true,
        formatter: (val) =>
          val !== null && val !== undefined ? val.toFixed(2) + " bar" : "--",
        color: value !== null && value < 1.0 ? "#ff4444" : "#fff",
        fontSize: 16,
        offsetCenter: [0, "45%"],
      },
      data: [{ value: value, name: title }],
    },
  ],
});

export const StcPressureGauges = ({ pressure1, pressure2 }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <ReactEcharts
        option={makeGaugeOption("Inlet", pressure1)}
        style={{ height: 200, width: "50%" }}
      />
      <ReactEcharts
        option={makeGaugeOption("Filtered", pressure2)}
        style={{ height: 200, width: "50%" }}
      />
    </div>
  );
};
